import '../../assets/index15.css';var C = Object.defineProperty, f = Object.defineProperties;
var y = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var _ = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var l = (o, e, t) => e in o ? C(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, b = (o, e) => {
  for (var t in e || (e = {}))
    _.call(e, t) && l(o, t, e[t]);
  if (r)
    for (var t of r(e))
      m.call(e, t) && l(o, t, e[t]);
  return o;
}, d = (o, e) => f(o, y(e));
var p = (o, e) => {
  var t = {};
  for (var c in o)
    _.call(o, c) && e.indexOf(c) < 0 && (t[c] = o[c]);
  if (o != null && r)
    for (var c of r(o))
      e.indexOf(c) < 0 && m.call(o, c) && (t[c] = o[c]);
  return t;
};
import { jsxs as N, jsx as n } from "react/jsx-runtime";
import { forwardRef as F } from "react";
import { ErrorMessage as I } from "../../molecules/ErrorMessage/index.js";
import { Label as v } from "../Label/index.js";
import { C as w, G as g } from "../../index-Bw0esb-9.js";
import { CheckFarFAIcon as j } from "../Icons/index.js";
const A = "Checkbox-module__container___FFDwI", E = "Checkbox-module__root___0NvcV", G = "Checkbox-module__body___iat8w", O = "Checkbox-module__input___FPIR1", R = "Checkbox-module__label___kt2po", V = "Checkbox-module__description___Opf1V", s = {
  container: A,
  root: E,
  body: G,
  input: O,
  label: R,
  description: V
}, B = ({ className: o }) => /* @__PURE__ */ n(j, { className: o }), h = F((L, x) => {
  var a = L, {
    error: o,
    description: e,
    mod: t,
    label: c,
    required: u,
    className: D
  } = a, k = p(a, [
    "error",
    "description",
    "mod",
    "label",
    "required",
    "className"
  ]);
  const i = !!o || void 0;
  return /* @__PURE__ */ N("div", { className: s.container, children: [
    /* @__PURE__ */ n(
      w,
      d(b({}, k), {
        "aria-invalid": i,
        classNames: {
          root: s.root,
          body: s.body,
          input: s.input,
          label: s.label
        },
        mod: { error: i },
        ref: x,
        label: /* @__PURE__ */ n(v, { label: String(c), withAsterisk: u }),
        icon: B
      })
    ),
    e && !o && /* @__PURE__ */ n("p", { className: s.description, children: e }),
    o && /* @__PURE__ */ n(I, { error: o })
  ] });
});
h.displayName = "Checkbox";
const J = Object.assign(h, { Group: g });
export {
  J as Checkbox,
  h as Item
};
